import {
  ButtonProps,
  InfoIcon,
  SuccessIcon,
  ToastProps,
} from "@volt_developers/components";

export type ToastVariant = ToastProps["variant"];
type ButtonVariant = ButtonProps["variant"];
type ToastButtonColor = "default" | "accent" | "danger";
type ToastGhostButtonColor = "ghost" | "ghost-blue";
type ToastButtonVariant = Extract<ButtonVariant, "solid" | "outlined">;

const buttonColorMap = new Map<ToastVariant, ToastButtonColor>([
  ["default", "default"],
  ["success", "accent"],
  ["failure", "danger"],
  ["info", "default"],
]);

const buttonVariantMap = new Map<ToastVariant, ToastButtonVariant>([
  ["default", "solid"],
  ["success", "outlined"],
  ["failure", "outlined"],
  ["info", "outlined"],
]);

const buttonGhostColorMap = new Map<ToastVariant, ToastGhostButtonColor>([
  ["default", "ghost-blue"],
  ["success", "ghost"],
  ["failure", "ghost"],
  ["info", "ghost"],
]);

export function useToast(variant: ToastVariant) {
  return {
    buttonColor: buttonColorMap.get(variant),
    buttonVariant: buttonVariantMap.get(variant),
    buttonGhostColor: buttonGhostColorMap.get(variant),
    iconComponent: variant === "success" ? <SuccessIcon /> : <InfoIcon />,
  };
}
